<div class="container-fluid" style="padding-right: 1rem; padding-left: 0.5rem;">
  <div class="row">

    <!-- LEFT SIDE: OTP -->
    <div
      class="col-lg-6 min-vh-lg-100 d-flex flex-column"
      style="background: transparent; position: relative;">

      <!-- LANGUAGE SWITCHER -->
      <div class="pt-4 ps-4">
        <div
          style="cursor: pointer;"
          class="svg-word-icon d-flex align-items-center"
          role="button"
          (click)="changeLanguage()">

          <svg
            role="button"
            style="width: 25px !important;"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64">

            <path d="M53.85 47.85A27 27 0 0 1 24 57.8V56l3-3v-4l4-4v-3l4 4h5l2-2h8z"/>
            <path d="M42 20.59v2.56L38.07 27H31l-5.36 5.26L31 37.51v5.06L27.44 39h-4.58L16 32.11V24.2L11.8 20h-4A27 27 0 0 1 32 5a26.55 26.55 0 0 1 7.06.94L36 9h-6v4l4 4h4.33z"/>
            <path d="M32 60a28 28 0 1 1 28-28 28 28 0 0 1-28 28zm0-54a26 26 0 1 0 26 26A26 26 0 0 0 32 6z"/>
          </svg>

          <span role="button" class="mx-2">
            {{'lang'|translate}}
          </span>

        </div>
      </div>

      <!-- OTP CARD CENTER -->
      <div class="flex-grow-1 d-flex justify-content-center align-items-center">

        <div class="otp-container">
          <div class="otp-card">

            <h2>{{'verify_OTP'|translate}}</h2>
            <p class="subtitle">{{'enter_OTP'|translate}}</p>

            <form (ngSubmit)="verifyOtp()">

              <div class="form-group">
                <input
                  type="text"
                  placeholder="{{'enter_OTP'|translate}}"
                  [(ngModel)]="otp"
                  name="otp"
                  maxlength="6"
                  required
                />
              </div>

              <button type="submit" [disabled]="loading">
                {{ loading ? ('verifying'|translate) : ('verify'|translate) }}
              </button>

              <div class="resend-container">

                <button
                  type="button"
                  class="resend-btn"
                  (click)="resendOtp()"
                  [disabled]="!canResend">

                  {{'resend_OTP'|translate}}

                </button>

                <p class="timer" *ngIf="!canResend">
                  {{'resend_timer'|translate}} {{ countdown }}s
                </p>

              </div>

              <p class="success" *ngIf="successMessage">
                {{ successMessage|translate }}
              </p>

              <p class="error" *ngIf="errorMessage">
                {{ errorMessage|translate }}
              </p>

            </form>

          </div>
        </div>

      </div>
    </div>

    <!-- RIGHT SIDE: IMAGE -->
    <div
      class="col-lg-6 d-none d-lg-flex justify-content-center min-vh-lg-100 position-relative px-0"
      [ngStyle]="{
        'background-image': 'url(' + backGroundImageSrc + ')',
        'background-size': 'cover',
        'background-position': 'center'
      }">
    </div>

  </div>
</div>
